// API helper for the Admitted/Discharged patient list (Task C18). Tenant
// headers are sent explicitly on every call — see bedTransferRequestApi.js /
// dischargeProcessApi.js.
//
// getAllocatedAdmissionForPatient (bedTransferRequestApi.js) hardcodes
// status=Allocated + a patient search term, and listAllocatedAdmissions
// (ipd-billing/billing-api.js) lives in the billing module with its own
// header/error-handling convention — neither cleanly fits a plain
// status-filtered list for this ipd-module page, so this is a small new
// helper matching the ipd/api/* convention instead.

import axios from "axios";

const BASE =
  process.env.REACT_APP_BACKEND_ROUTE_URL ||
  "https://manage-dev.hlthtek.com/app/api/";

function authHeaders(extra = {}) {
  const token = sessionStorage.getItem("accessToken") || "";
  return {
    Authorization: `Bearer ${token}`,
    "APP-MODE": sessionStorage.getItem("APP_MODE") || "",
    "ORG-CODE": sessionStorage.getItem("ORG_CODE") || "",
    "USER-ACCESS-KEY": sessionStorage.getItem("USER_ACCESS_KEY") || "",
    USERNAME: sessionStorage.getItem("userName") || "",
    ...extra,
  };
}

// GET ipd_admission/ rows filtered by status ("Admitted" | "Discharged").
// Response is {status: "Success", count, data: [...]} — see
// main/ipd/manage_admission.py ManageIPDAdmissionView.get(). No is_valid key
// on a successful response (only present, and false, on the invalid-user-
// access failure path — same guard as every other endpoint).
export async function listAdmissions(status) {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  const qs = params.toString();
  const res = await axios.get(`${BASE}ipd_admission/${qs ? `?${qs}` : ""}`, {
    headers: authHeaders(),
  });
  return res?.data?.data || [];
}
